(function() {
  document.querySelectorAll('.zlots__col').forEach(function(col) {
    col.addEventListener('touchstart', function() {
      col.classList.add('paused');
    }, { passive: true });

    col.addEventListener('touchend', function() {
      setTimeout(function() {
        col.classList.remove('paused');
      }, 1000);
    }, { passive: true });
  });
})();